import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

export function requestSupplementaryBillsList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/supplementary-bills`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/supplementary-bills?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestSupplementaryBillsCreate(data) {
  return fetch.post(`${BASE_URL}/api/app/supplementary-bills`, data);
}

export function requestSupplementaryBillsUpdate(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/supplementary-bills/${data._id}`, body);
}

export function requestSupplementaryBillsDelete(data) {
  return fetch.delete(`${BASE_URL}/api/app/supplementary-bills/${data}`);
}

export function requestSupplementaryBillsReportUpdateStatus(data) {
  const body = { data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/supplementary-bills/update/list`, data);
}

export function requestGetByIdSupplementaryBills(data) {
  return fetch.get(`${BASE_URL}/api/app/supplementary-bills/getById/${data.id}`);
}